// extracted by mini-css-extract-plugin
module.exports = {"page_container":"LaserficheEmbed_page_container__23-7q","iframe_container":"LaserficheEmbed_iframe_container__dv2mh"};